import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MrService } from '../mr.service';

@Component({
  selector: 'app-mr-signup',
  templateUrl: './mr-signup.component.html',
  styleUrls: ['./mr-signup.component.css']
})
export class MrSignupComponent implements OnInit {
  mrform!:FormGroup

  constructor( private mrservice:MrService) { }

  ngOnInit(): void {

    this.mrform= new FormGroup({
      name : new FormControl(null,Validators.required),
      email : new FormControl(null,Validators.required),
      phone : new FormControl(null,Validators.required),
      designation : new FormControl(null,Validators.required),
      password : new FormControl(null,Validators.required),
    })
  }

  onSubmit(){
    let dt = this.mrform.value
    console.log(dt);
    let payload = {
      name :dt.name,  
       email:dt.email,
       phone:dt.phone,
       designation:dt.designation,
       password: dt.password
    }
    this.mrservice.signupMr(payload).subscribe((res:any)=>{
      console.log("successfully signup",res)
    })
    

  }



}
